import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: '#FEFCF1',
    borderRadius: 18,
    padding: theme.spacing(3),
  },
  tabs: {
    minHeight: theme.spacing(5),
    marginBottom: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
      marginBottom: theme.spacing(5),
    },
  },
  indicator: {
    backgroundColor: '#FFCE36',
  },
  tab: {
    color: theme.palette.primary.dark,
    fontWeight: 650,
    whiteSpace: 'nowrap',
    minHeight: 36,
    minWidth: 0,
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    textTransform: 'none',
    '&.Mui-selected': {
      color: '#FFCE36',
    },
  },
  tabPanelContainer: {
    marginTop: theme.spacing(-6),
    padding: theme.spacing(2),
  },
  tabPanelContentImage: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: theme.spacing(6),
    marginBottom: theme.spacing(3),
    [theme.breakpoints.up('md')]: {
      marginTop: theme.spacing(0),
      marginBottom: theme.spacing(0),
    },
  },
  tabPanelContentText: {
    textAlign: 'center',
    [theme.breakpoints.up('md')]: {
      textAlign: 'left',
    },
  },
  tabPanelContentTitle: {
    color: theme.palette.primary.dark,
    marginBottom: theme.spacing(2),
    fontSize: 36,
    [theme.breakpoints.up('md')]: {
      marginTop: theme.spacing(5),
    },
  },
  tabPanelContentMainDescription: {
    color: theme.palette.grey[200],
    fontSize: 20,
    fontWeight: 600,
    marginBottom: theme.spacing(5),
  },
  tabPanelContentSubTitle: {
    color: theme.palette.primary.dark,
    marginBottom: theme.spacing(2),
    [theme.breakpoints.up('md')]: {
      marginTop: theme.spacing(5),
    },
  },
  tabPanelContentDescription: {
    color: theme.palette.grey[200],
    marginBottom: theme.spacing(4),
  },
  textDark: {
    color: theme.palette.primary.dark,
  },
  tabPanelContentPrice: {
    textAlign: 'center',
    position: 'relative',
    color: theme.palette.grey[200],
    backgroundColor: '#FEF7CA',
    borderRadius: theme.spacing(2),
    marginLeft: 'auto',
    marginRight: 'auto',
    marginBottom: theme.spacing(4),
    marginTop: theme.spacing(4),
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),

    [theme.breakpoints.up('xs')]: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexWrap: 'nowrap',
    },
  },
  tabPanelPriceImage: {
    position: 'absolute',
    left: '-50px',
    [theme.breakpoints.down('xs')]: {
      top: '-80px',
      marginLeft: 'auto',
      marginRight: 'auto',
      left: 0,
      right: 0,
    },
  },
  tabPanelPrice: {
    maxWidth: '100%',
    padding: theme.spacing(2),
    flexGrow: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginLeft: theme.spacing(8),
    [theme.breakpoints.down('xs')]: {
      display: 'block',
      marginLeft: theme.spacing(0),
    },
  },
  tabPanelPriceButton: {
    backgroundColor: theme.palette.primary.dark,
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
    },
    [theme.breakpoints.down('xs')]: {
      marginTop: theme.spacing(4),
    },
  },
  tabPanelPriceText: {
    flexGrow: 1,
    [theme.breakpoints.down('xs')]: {
      marginTop: theme.spacing(6),
    },
  },
}))

export default useStyles
